module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no1-955f8d957cc0d6ebfe5b8cb5fb344f02.png";